module.exports = __webpack_public_path__ + "static/media/children2.bfe20902.png";